export enum PropertySaleActions {}
